
import { connect } from 'react-redux';

import { withRouter } from 'react-router-dom';

import { login, signup, logout, clearErrorsAction } from '../../actions/session_actions';

import { forgotPassword } from '../../actions/user_actions';

import RegisterIndividualPage from './register_individual_page';

const mapStateToProps = (state, ownProps) => {

  const loggedIn = Boolean(state.session.currentUser)
  let currentUser = loggedIn ? state.session.currentUser : null;
  let errors = state.errors.session;

  return {
    currentUser,
    loggedIn,
    errors
  };
};

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(logout()),
  signup: user => dispatch(signup(user)),
  login: user => dispatch(login(user)),
  clearErrors: user => dispatch(clearErrorsAction()),
  forgotPassword: data => dispatch(forgotPassword(data)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RegisterIndividualPage));
